// extracted by mini-css-extract-plugin
export default {"content":"Home_content__A9UD8","logo":"Home_logo__qVohZ"};